import React, { useState } from 'react';
import { translate } from 'components/Translation';
import { SingleBillId } from 'utils/api/models/bills/singleBillId';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingAccounts/billingAccountsStyle';
import Verification from 'assets/img/icons/verification.svg';
import { makeStyles } from '@material-ui/core';
import { DisplayS, BodyS, BodySBold } from 'components/Typography/Typography';
import OTP from 'components/OTP/OTP';

interface IBillingAccount extends SingleBillId {
	account?: SingleCorpAccount;
}

interface OTPDialogProps {
	values: DeleteValues;
	handleDelete: (token: string) => void;
	handleCancel: () => void;
}

export interface DeleteValues {
	contactNumber: string;
	otpError: boolean;
	accountToDelete: IBillingAccount | null;
}

const DeleteOTP = (props: OTPDialogProps) => {
	const classes = makeStyles(styles)();
	const [otp, setOTP] = useState('');
	return (
		<CustomDialog
			isOpen
			hideDialog={() => props.handleCancel()}
			dialogBody={
				<div className={classes.dialogBody}>
					<img src={Verification} alt="verification" />
					<div className={classes.dialogHeader}>
						<DisplayS disableMargin>{translate('payments.billingAccounts.verificationRequired')}</DisplayS>
					</div>
					<div className={classes.subheader}>
						<BodyS color="secondary-light" disableMargin>
							{translate(
								'active.services.delete.billing.account.subheader',
								String(props.values.accountToDelete?.billingId),
								String(props.values.accountToDelete?.billingAccountName)
							)}
						</BodyS>
					</div>
					<div className={classes.header}>
						<BodyS inline>
							{translate('active.services.add.billing.account.you.will.receive.password')}
						</BodyS>{' '}
						<BodySBold inline>{props.values.contactNumber}</BodySBold>
					</div>
					<BodyS>{translate('active.services.add.billing.account.enter.password')}</BodyS>

					<OTP otpValue={otp} setOtpValue={setOTP} otpIncorrect={props.values.otpError} />
				</div>
			}
			rightSideButtons={[
				{
					text: translate('cancel'),
					color: 'tertiary-light',
					onClick: props.handleCancel,
				},
				{
					text: translate('confirm'),
					color: 'primary-light',
					onClick: () => props.handleDelete(otp),
					disabled: otp.length !== 5,
				},
			]}
		/>
	);
};

export default DeleteOTP;
